<div
  class="main-best-hotels-container"
  [class]="themeService.getTheme()"
  [style]="getStyle()"
  [style.padding]="paddingLess ? '0' : ''"
  [style.padding-top]="paddingStyle"
  *ngIf="cards.length > 0 || isLoadingMore"
>
  <div *ngIf="title" class="best-hotels-title">
    <app-texts [texts]="texts"/>
  </div>
  <div *ngIf="subtitle" class="best-hotels-subtitle">
    <app-texts
      class="best-hotels-subtitle-text"
      [texts]="[
                {text: subtitleText}
              ]"
    />
    <div *ngIf="search" class="best-hotels-search-container">
      <div class="best-hotels-search-icon-container" [style.opacity]="searchInputValue.length > 0 ? 1 : 0.1">
        <div class="best-hotels-search-icon">
          <img src="app/assets/icons/key.svg">
        </div>
      </div>
      <div class="best-hotels-search-input">
        <input
          placeholder="{{ getPlaceHolder() }}"
          [(ngModel)]="searchInputValue"
          [style]="isMobile ? '' : 'text-transform: uppercase'"
          (ngModelChange)="onSearchInputChange($event)"
        >
      </div>
    </div>
  </div>
  <div class="best-hotels-container">
    <app-hotel-gallery
      [cards]="getArray('first')"
      [cardsLength]="cardsLength"
      [startIndex]="0"
      (sliderEndReached)="onSliderEndReached()"
      (sliderComponentReady)="registerFirstSlider($event)"
    />
  </div>
  <div class="best-hotels-container" *ngIf="secondArray.length > 0">
    <app-hotel-gallery
      [cards]="getArray('second')"
      [startIndex]="firstArray.length"
      [firstArray]="false"
      (sliderEndReached)="onSliderEndReached()"
      (sliderComponentReady)="registerSecondSlider($event)"
    />
  </div>
  <div class="best-hotels-search-null" *ngIf="filterNull && search">
    <div class="best-hotels-search-null-el">
          <span>
          <app-texts
            [texts]="[
            {text: ['Отель, соответствующий вашему запросу, не найден.', 'The hotel matching your request was not found.'], transfer: true},
          ]"
          />
        </span>
    </div>
    <div class="best-hotels-search-null-el">
          <span (click)="openWhatsApp()" style="cursor:pointer;">
            <app-texts
              [texts]="firstText"
            />
          </span>
      <span [style]="isMobile ? '' : 'margin-left: 0.5ch'" *ngIf="!isMobile">
          <app-texts
            [texts]="secondText"
          />
        </span>
    </div>
  </div>
</div>
